import LeaseTerms from './LeaseTerms_v1';
import type { Lease, Section } from '../../../models/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
};

export default function LeaseTerms_v2(props: Props): JSX.Element {
  return <LeaseTerms {...props} />;
}
